<template>
  <v-container style="margin-top: 185px; max-width: 500px;">
    <v-form ref="form" @submit.prevent="submitForm">
      <v-text-field v-model="newUserForm.username" label="Username"
        :rules="usernameRules"
        :error-messages="usernameError"
        :loading="checkingUsername"
        :append-inner-icon="usernameIcon"
        :color="usernameAvailable ? 'success' : undefined"
      ></v-text-field>
      <v-text-field v-model="newUserForm.email" label="Email" type="email" :rules="[v => !!v && v.trim().length > 0 || 'Email is required']"></v-text-field>
      <v-text-field v-model="newUserForm.name" label="Name" required></v-text-field>
      <v-text-field v-model="newUserForm.phone" label="Phone" :rules="[v => !!v && v.trim().length > 0 || 'Phone is required']"></v-text-field>
      <v-text-field v-model="newUserForm.password" label="Password" type="password" required></v-text-field>
      <v-select
          v-model="newUserForm.default_role"
          label="Default Role"
          :items="defaultRoleOptions"
          item-title="label"
          item-value="value"
          dense
          outlined
      ></v-select>
      <v-autocomplete
          v-model="newUserForm.client_id"
          v-model:search="clientSearchText"
          label="Select Client"
          :items="clientsList"
          item-title="displayName"
          item-value="id"
          :loading="loadingClients"
          clearable
          auto-select-first
          dense
          outlined
          required
          @focus="clientSearchText = ''"
      >
        <template v-slot:item="{ props, item }">
          <v-list-item v-bind="props" :subtitle="item.raw.isOwn ? 'Own Client' : 'Subclient'"></v-list-item>
        </template>
      </v-autocomplete>

      <v-btn type="submit" color="primary">Add User</v-btn>
      <v-btn @click="cancelAddNewUser" color="error">Cancel</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import axios from 'axios';
import {getClientTree} from '@/composables/useGetClientsAPI';
import {log} from "@/composables/useLog";
import useGetLoggedIn from "@/composables/useGetLoggedIn";
import useAddNewUserApi from "@/composables/useAddNewUser"
import {BASE_URL} from "@/composables/url_config";
export default {
  data() {
    return {
      newUserForm: {
        username: '',
        email: '',
        name: '',
        phone: '',
        password: '',
        default_role: '',
        client_id: null,
      },
      defaultRoleOptions: [
        { label: 'None', value: '' },
        { label: 'Default Admin L0', value: 'default_admin_l0' },
        { label: 'Default Admin L1', value: 'default_admin_l1' },
        { label: 'Default Admin L2', value: 'default_admin_l2' },
      ],
      clients: [],
      errorMessage: null,
      errorDialog: null,
      subclientsList:[],
      client_id: null,
      token: null,
      user: null,
      selected_client_name: null,
      clientSearchText: '',
      loadingClients: false,
      checkingUsername: false,
      usernameAvailable: null,
      usernameError: '',
      usernameDebounceTimer: null,
      usernameRules: [
        v => !!v && v.trim().length > 0 || 'Username is required',
      ],
    };
  },
  computed: {
    usernameIcon() {
      if (this.checkingUsername) return ''
      if (this.usernameAvailable === true) return 'mdi-check-circle'
      if (this.usernameAvailable === false) return 'mdi-close-circle'
      return ''
    },
    clientsList() {
      const list = [];
      if (this.user && this.user.userClient) {
        list.push({
          id: this.user.userClient.id,
          name: this.user.userClient.name,
          displayName: this.user.userClient.name,
          isOwn: true
        });
      }
      const addSubclientsRecursively = (clients, level = 1) => {
        if (!clients || clients.length === 0) return;
        clients.forEach(subclient => {
          const indent = '—'.repeat(level) + ' ';
          list.push({
            id: subclient.client_id || subclient.id,
            name: subclient.name,
            displayName: indent + subclient.name,
            isOwn: false,
            level: level
          });
          if (subclient.children && subclient.children.length > 0) {
            addSubclientsRecursively(subclient.children, level + 1);
          }
        });
      };
      addSubclientsRecursively(this.subclientsList);
      return list;
    }
  },
  watch: {
    'newUserForm.username'(val) {
      clearTimeout(this.usernameDebounceTimer)
      this.usernameAvailable = null
      this.usernameError = ''

      if (!val || val.trim().length < 4) return

      this.usernameDebounceTimer = setTimeout(() => {
        this.checkUsername(val.trim())
      }, 400)
    }
  },
  methods: {
    async checkUsername(username) {
      this.checkingUsername = true
      try {
        const res = await axios.get(`${BASE_URL}/home/check_username_availability`, {
          params: { username },
          headers: { Authorization: `Bearer ${this.token}` }
        })
        if (res.data.exists) {
          this.usernameAvailable = false
          this.usernameError = 'Username already taken'
        } else {
          this.usernameAvailable = true
          this.usernameError = ''
        }
      } catch (err) {
        log('checkUsername error: ' + err)
      } finally {
        this.checkingUsername = false
      }
    },
    restoreValue(){
     this.selected_client_name=this.user.userClient.name
    },
    updateFormClientId(selected_client){
      this.selected_client_name=selected_client.selected_client_name
    },
    async fetchClientTree() {
      try {
        const response = await getClientTree(this.token,this.client_id);
        if (response.error) {
          this.errorMessage = response.error_title || "Error";
          this.errorDialog = true;
        } else {
          log("ne.am intors din fetchClientTree si am primit response")
          log(response)
          this.subclientsList =  response.clients_list[0].children ;
          this.$emit("showAddNewUserEvent");
        }
      } catch (err) {
        console.error("Error fetching client tree:", err);
        this.errorMessage = "Unexpected error occurred.";
        this.errorDialog = true;
      }
    },
    async submitForm() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return
      if (this.usernameAvailable === false) return
      const {addNewUserApi}=useAddNewUserApi()
      addNewUserApi(this.token, this.newUserForm).then((data)=>{
        log(data)
        alert(data.message)
        this.$emit('cancelAddNewUserEvent')
      })
    },
    cancelAddNewUser() {
      this.$router.push({ name: 'dashboard' });
    }
  },
  mounted() {
  },
  created() {
    const { getLoggedIn, user, loggedIn, token } = useGetLoggedIn();
    getLoggedIn().then(() => {
      log("dupa created in Dashboard avem:");
      log("autorizare in Dashboard after getLoggedIn");
      log("user:");
      log(user);
      log("loggedIn: " + loggedIn.value);
      log("token: " + token.value);
      this.client_id=user.value.client_id
      this.token=token.value
      this.user=user.value
      this.selected_client_name=null
      this.fetchClientTree()
    })
  },
};
</script>
